<!-- eslint-disable -->
<template>
    <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2">
            <!-- Login v1 -->
            <b-card class="mb-0">
                <b-link class="brand-logo" :to="{ name: 'auth-login' }">
                    <b-img
                        :src="empresa.logo"
                        alt="Icon"
                        style="max-width: 150px; max-height: 200px"
                    />
                </b-link>

                <b-card-title class="mb-1">
                    Portal de Clientes {{ empresa.nombre }}! 👋
                </b-card-title>

                <!-- form -->
                <validation-observer ref="loginForm" #default="{ invalid }">
                    <b-form
                        class="auth-login-form mt-2"
                        @submit.prevent="login"
                    >
                        <!-- email -->
                        <b-form-group label-for="email" label="Email">
                            <validation-provider
                                #default="{ errors }"
                                name="Email"
                                rules="required|email"
                            >
                                <b-form-input
                                    id="email"
                                    v-model="userEmail"
                                    name="login-email"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder=""
                                    autofocus
                                    autocapitalize="none"
                                />
                                <small class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>

                        <!-- password -->
                        <b-form-group>
                            <div class="d-flex justify-content-between">
                                <label for="password">Password</label>
                                <b-link
                                    :to="{
                                        path: `/forgot-password/${userEmail}`,
                                        params: { email: userEmail },
                                    }"
                                >
                                    <small style="font-size: 14px">
                                        Olvido su contraseña?
                                    </small>
                                </b-link>
                            </div>
                            <validation-provider
                                #default="{ errors }"
                                name="Password"
                                rules="required"
                            >
                                <b-input-group
                                    class="input-group-merge"
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                >
                                    <b-form-input
                                        id="password"
                                        v-model="password"
                                        :type="passwordFieldType"
                                        class="form-control-merge"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        name="login-password"
                                        placeholder="Password"
                                    />

                                    <b-input-group-append is-text>
                                        <feather-icon
                                            class="cursor-pointer"
                                            :icon="passwordToggleIcon"
                                            @click="togglePasswordVisibility"
                                        />
                                    </b-input-group-append>
                                </b-input-group>
                                <small class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>

                        <!-- checkbox -->
                        <b-form-group>
                            <b-form-checkbox
                                id="remember-me"
                                v-model="status"
                                name="checkbox-1"
                            >
                                Recuerdame
                            </b-form-checkbox>
                        </b-form-group>

                        <!-- submit button -->
                        <b-button
                            v-if="!isLoading"
                            variant="primary"
                            type="submit"
                            block
                            :disabled="invalid"
                            style="color: #004e7c"
                        >
                            INICIAR SESIÓN
                        </b-button>

                        <b-button
                            v-if="isLoading"
                            variant="primary"
                            disabled
                            block
                        >
                            <b-spinner small />
                            Loading...
                        </b-button>
                    </b-form>
                </validation-observer>
            </b-card>
            <!-- /Login v1 -->
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { email, required } from '@validations'
import {
    BAlert,
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    BLink,
    BSpinner,
    VBTooltip,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
    directives: {
        'b-tooltip': VBTooltip,
    },
    components: {
        BButton,
        BForm,
        BFormInput,
        BFormGroup,
        BCard,
        BCardTitle,
        BLink,
        VuexyLogo,
        BCardText,
        BInputGroup,
        BSpinner,
        BInputGroupAppend,
        BFormCheckbox,
        BAlert,
        ValidationProvider,
        ValidationObserver,
        ToastificationContent,
        BImg,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            status: '',
            password: '',
            userEmail: '',
            device_name: '',
            sideImg: require('@/assets/images/pages/login-trantor.png'),
            required,
            email,
            isLoading: false,
            empresa: {
                nombre: '',
                logo: '',
            },
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password'
                ? 'EyeIcon'
                : 'EyeOffIcon'
        },
        imgUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require('@/assets/images/pages/login-trantor.png')
                return this.sideImg
            }
            return this.sideImg
        },
    },
    created() {
        this.$http
            .get('empresa/1')
            .then((response) => {
                this.empresa.nombre = response.data.data.nombre_comercial
                this.empresa.logo = response.data.data.logo
            })
            .catch(function (error) {
                console.log(error)
            })
    },
    mounted() {
        this.userEmail =
            this.$route.params.email != 'undefined'
                ? this.$route.params.email
                : null
    },
    methods: {
        login() {
            this.$refs.loginForm.validate().then((success) => {
                if (success) {
                    this.isLoading = true
                    this.device_name = this.consultarDevice()
                    this.$http
                        .post('auth/login', {
                            email: this.userEmail,
                            password: this.password,
                            device_name: this.device_name,
                        })
                        .then((response) => {
                            // .then(response => console.log(response))
                            const msn = response.data.msm
                            if (msn == 'SI') {
                                useJwt.setToken(response.data.accessToken)
                                useJwt.setRefreshToken(
                                    response.data.refreshToken
                                )
                                localStorage.setItem(
                                    'userData',
                                    JSON.stringify(response.data.userData)
                                )
                                localStorage.setItem(
                                    'access',
                                    JSON.stringify(response.data.access)
                                )
                                this.$ability.update(
                                    response.data.userData.ability
                                )
                                // notificatio
                                this.showToast(
                                    response.data.message,
                                    'success',
                                    'EditIcon'
                                )
                                this.$router.push('/')
                                // this.$router.replace("invoice/add");
                                this.isLoading = false
                            } else {
                                this.showToast(
                                    'Contraseña o Email INCORRECTOS',
                                    'danger',
                                    'IconCancel'
                                )
                                this.isLoading = false
                            }
                        })
                        .catch((error) => {
                            this.showToast(
                                error.message,
                                'danger',
                                'IconCancel'
                            )
                            this.isLoading = false
                        })
                }
            })
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant,
                    icon,
                },
            })
        },
        consultarDevice() {
            let browser = ''
            let browserVersion = 0
            if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = 'Opera'
            } else if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
                browser = 'MSIE'
            } else if (/Navigator[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = 'Netscape'
            } else if (/Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = 'Chrome'
            } else if (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = 'Safari'
                ;/Version[\/\s](\d+\.\d+)/.test(navigator.userAgent)
                browserVersion = new Number(RegExp.$1)
            } else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                browser = 'Firefox'
            }
            if (browserVersion === 0) {
                browserVersion = parseFloat(new Number(RegExp.$1))
            }
            return `${browser}*${browserVersion}`
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
